var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReserve({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.97 18.209V19.209C21.97 20.859 21.97 22.209 18.97 22.209H4.96997C1.96997 22.209 1.96997 20.859 1.96997 19.209V18.209C1.96997 17.659 2.41997 17.209 2.96997 17.209H20.97C21.52 17.209 21.97 17.659 21.97 18.209Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 5.38876C14.46 5.18876 14.49 4.99876 14.5 4.78876C14.53 3.62876 13.82 2.60876 12.7 2.30876C11.02 1.84876 9.50002 3.10876 9.50002 4.70876C9.50002 4.94876 9.53002 5.16876 9.59002 5.38876C5.98002 6.15876 3.27002 9.36876 3.27002 13.2088V14.7088C3.27002 15.2588 3.72002 15.7088 4.27002 15.7088H19.72C20.27 15.7088 20.72 15.2588 20.72 14.7088V13.2088C20.72 9.36876 18.02 6.16876 14.41 5.38876ZM15 11.9588H9.00002C8.59002 11.9588 8.25002 11.6188 8.25002 11.2088C8.25002 10.7988 8.59002 10.4588 9.00002 10.4588H15C15.41 10.4588 15.75 10.7988 15.75 11.2088C15.75 11.6188 15.41 11.9588 15 11.9588Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReserve);
export default __webpack_public_path__ + "static/media/icon_reserve.d9dc5ba243ad252d94db9e950e07226d.svg";
export { ForwardRef as ReactComponent };